<template>
  <div>
    <div class="buyerInformation" v-show="step == 1">
      <div class="buyerInformation-top">
        <div class="top-con">
          <div class="container">
            <div class="buyerInformation-title">买家信息表单</div>
            <span>订单编号：{{ order_no }}</span>
          </div>
          <div class="logo"></div>
        </div>
      </div>
      <div class="buyerInformation-main">
        <div class="certContractSign-card-body">
          <el-form
            class="certContractSign-card-body-form"
            :label-width="labelWidth"
            :label-position="labelPostion"
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
          >
            <!-- 上半部分 -->
            <div class="certContractSign-card-body-form-top">
              <div class="certContractSign-card-body-form-top-content">
                <div class="sign-type">
                  <el-form-item
                    class="certContractSign-card-body-form-top-content-from"
                    label="请选择保障证明文件："
                    prop="sign_type"
                  >
                    <el-radio-group v-model="ruleForm.sign_type">
                      <el-radio :label="1">交易合同</el-radio>
                      <el-radio :label="2">包赔证明</el-radio>
                    </el-radio-group>
                    <div class="sign-type-tip">
                      <i class="el-icon-warning"></i>
                      包赔证明与交易合同享有相同权益
                    </div>
                  </el-form-item>
                  <div class="sign-tip" v-show="ruleForm.sign_type" @click="ruleForm.sign_type == 2 ? signVisible = true : quitVisible = true">
                    {{ ruleForm.sign_type == 2 ? '包赔证明示范图' : '交易合同示范图' }}
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
              </div>
            </div>

            <!-- 下半部分 -->
            <div class="certContractSign-card-body-form-bottom" v-show="ruleForm.sign_type">
              <div class="certContractSign-card-body-form-top-title bottom-title">
                <span class="certContractSign-card-body-form-top-title-gameinfo" style="letter-spacing: 4px;"
                  >{{ ruleForm.sign_type == 1 ? '签约人信息' : '本人信息'}}</span
                >
                <img src="@/assets/image/Contract/danger.png" v-if="ruleForm.sign_type == 1" alt="" />
                <span class="certContractSign-card-body-form-bottom-tip" v-if="ruleForm.sign_type == 1"
                  >签署电子合同需保证实名，且需年满18周岁</span
                >
              </div>
              <div class="certContractSign-card-body-form-bottom-content">
                <ContractingParty :countryList="countryList" :partyData="partyData" @handleActive="handleActive" @refreshData="getSignatoryList()" v-if="ruleForm.sign_type == 1"></ContractingParty>
                <template v-else>
                  <el-form-item
                    label="姓名"
                    class="certContractSign-card-body-form-bottom-content-realname"
                    prop="name"
                    label-width="136px"
                  >
                    <template #error>
                      <div class="prop-fail">
                        <img src="@/assets/image/Contract/err.png" alt="" />
                        <span>请输入正确的姓名</span>
                      </div>
                    </template>
                    <el-input
                      placeholder="请输入姓名"
                      v-model="ruleForm.name"
                      maxlength="10"
                      :disabled="nameDisable"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="电话号码"
                    class="certContractSign-card-body-form-bottom-content-realname"
                    prop="phone"
                    label-width="136px"
                  >
                    <template #error>
                      <div class="prop-fail">
                        <img src="@/assets/image/Contract/err.png" alt="" />
                        <span>请输入正确的电话号码</span>
                      </div>
                    </template>
                    <el-input
                      placeholder="请输入电话号码"
                      v-model="ruleForm.phone"
                    ></el-input>
                  </el-form-item>
                </template>
              </div>
            </div>
          </el-form>
          <div class="buyerInformation-btn">
            <el-button v-preventReClick='1500' :loading="btnLoading" @click="saveInfo" class="sub"
              >提交</el-button
            >
          </div>
          <!-- <div class="certContractSign-card-body-form-bottom-img">
            <img src="@/assets/image/Contract/fddTip.png" alt="" />
            <span>本平台电子合同由法大大提供技术支持</span>
          </div> -->
        </div>
      </div>
    </div>
    <buyerInformationMobile v-if="step == 2"></buyerInformationMobile>
    <!-- 三方示范图弹窗 -->
    <div v-show="quitVisible" class="quit-mark" @click="quitVisible=false">
      <div class="quit-box">
        <i class="el-icon-close"></i>
        <img src="@/assets/image/Contract/threeContract.png"/>
        <div class="quit_btn" @click="goTherePdf">点击预览三方合同文件<i class="el-icon-arrow-right"></i></div>
      </div>
    </div>
    <!-- 包赔示范图弹窗 -->
    <div v-show="signVisible" class="quit-mark" @click="signVisible=false">
      <div class="quit-box">
        <i class="el-icon-close"></i>
        <img src="@/assets/image/Contract/signContract.png"/>
        <div class="quit_btn" @click="goSignPdf">点击预览包赔证明文件<i class="el-icon-arrow-right"></i></div>
      </div>
    </div>
    <!-- :btn-text="`去实名${_isMobile() ? '' : '(' + goRealNameTime + 'S)'}`" -->
    <myDialog
      title="实名认证"
      text="您提交的信息法大大未实名，请准备好身份证进行实名认证"
      btn-text="去实名"
      btn
      :show="showRealNameDialog"
      :close-fun="closeRealNameDialog"
      :btn-fuc="goRealName"
    >
      <div slot="tip" class="dialog-realname">
        <i class="el-icon-warning"></i>
        若实名不成功,请联系客服更换签约人信息
      </div>
    </myDialog>
  </div>
</template>

<script>
import { apiContractBuyerInformation, signatoryList, apiContractSellerInformationAdd, apiBuyerInformationAdd } from "../../request/API";
import buyerInformationMobile from './buyerInformationMobile.vue';
import { addressArea } from './newMap'
import ContractingParty from "./components/ContractingParty.vue";
import myDialog from "@/components/myDialog";
/**
 * 表单验证失败时 滚动到第一个error位置
 */
 const scrollIntoView = (className = "is-error", block = "center") => {
    Promise.resolve().then(() => {
       const target = document.getElementsByClassName(className);
     if (target.length) {
        target[0].scrollIntoView({
           behavior: "smooth",
           block: block,
       });
    }
  });
};

const is_mobile = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
);
let codes = require('../../assets/json/coutryCode.json')
export default {
  components: { buyerInformationMobile,ContractingParty, myDialog },
  name: "submitSuccess",
  data() {
    return {
      lastUseList: [
        {label: '是', value: 1},
        {label: '否', value: 0},
      ],
      goRealNameTime: 3,
      readnameUrl: '',
      showRealNameDialog: false,
      // 包赔姓名是否禁用
      nameDisable: false,
      // 三方示范图
      quitVisible: false,
      // 包赔示范图
      signVisible: false,
      btnLoading: false,
      ocrLoading: false,
      loading: false,
      order_no: "",
      ruleForm: {
        sign_type: '',
        name: '',
        phone: '',
      },
      signActiveId: '',
      rules: {
        sign_type: {
          required: true,
          message: "请选择保障证明文件",
          trigger: "change",
        },
        name: [
          {required: true,  message: "请输入姓名", trigger: 'blur'},
        ],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
      },
      provinceList: [],
      cityList: [],
      districtList: [],
      countryList: codes.splice(4,codes.length),
      ChinaAddressArea: [],
      // 订单id
      order_id: '',
      // 房间id
      room_id: '',
      // token
      userToken: '',
      loadingback: false,
      app_status: 1,
      admin_id: '',
      step: 1,
      id: '',
      auditStatus: '',
      //选择证明文件
      accSourceList: [
        {label: '交易合同', value: 1},
        {label: '包赔证明', value: 2},
      ],
      //联系地址
      countryTypeList:[
        {label: '国内', value: 1},
        {label: '国外', value: 2},
      ],
      //签约信息表单 手机端
      editPartyShow:false,
      editPartyForm: {
        last_use: 1,
        name: '',
        card_id: '',
        country_type: 1,
        country_code: '',
        province: '',
        city: '',
        area: '',
        address: '',
        phone: '',
      },
      editPartyRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        card_id: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          { validator: this.validate, trigger: ['change', 'blur'] }
        ],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        country_type: [{ required: true, message: "请选择联系地址", trigger: "change" }],
        address: [
          { required: true, message: "请完善联系地址", trigger: "blur" },
          {
            min: 5,
            message: "请输入准确现住地址",
            trigger: "blur",
          },
        ],
      },
      monitorKeyboard:null,
      //签约人列表
      partyData:[]
    };
  },
  computed: {
    labelPostion() {
      return is_mobile ? "top" : "left";
    },
    labelWidth() {
      return is_mobile ? "auto" : "204px";
    },
  },
  created() {
    this.order_id = this.$route.query.o
    this.room_id = this.$route.query.r
    this.admin_id = this.$route.query.a
    this.userToken = this.$route.query?.t || this.$route.query?.token

    if(this.userToken){
      let status = true
      this.$store.commit('set_token', this.userToken)
      this.$store.commit('set_loginStatus', status)
      this.app_status = 2
    } else{
      if (this.$store.state.loginStatus) {
        this.app_status = 1
        // this.step = 1
      } else{
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.fullPath
          },
        })
        return;
      }
    }
    apiContractBuyerInformation({
      rd: this.$route.query.rd,
      order_id: this.order_id,
      client: this.userToken ? 'moblie' : 'front'
    }).then(res => {
      if(this.userToken){
        this.step = 2
      }
      this.id = res.data.id
      this.auditStatus = res.data.status
      this.order_no = res.data.order_no
      this.ruleForm.name = res.data.cert_name
      this.ruleForm.phone = res.data.phone
      // if(this.ruleForm.name != ''){
      //   this.nameDisable = true
      // }
      if(Number(this.id)>0){
        location.href = `/burerSubmitOutcome?order_no=${this.order_no}`
      }
    }).catch(err => {
      this.$message({
        message: err.msg,
        center: true,
        offset: 200,
        customClass: 'sell-contract-msg'
      })
      setTimeout(() => {
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.fullPath
          },
        })
      },3000)
    })
    this.getSignatoryList()
  },
  mounted() {
    this.ChinaAddressArea = addressArea
  },
  methods: {
    goTherePdf(){
      window.open('https://images.pxb7.com/file/contract.pdf','_blank')
    },
    goSignPdf() {
      window.open('https://images.pxb7.com/file/indemnity.pdf','_blank')
    },
    handleActive({id}){
      this.signActiveId = id
    },
    /**
     * @description: 获取签约人列表
     * @return {*}
     */
    getSignatoryList() {
      signatoryList({
        client: this.userToken ? 'moblie' : 'front'
      }).then(res => {
        this.partyData = res.data
        this.handleActive({id: this.partyData[0]?.id})
      })
    },
    /**
     * @description: 重置
     * @return {*}
     */
    resetInfo() {
      // this.ruleForm.sign_type = 1
      this.ruleForm.phone = ''
      // if(!this.nameDisable){
        this.ruleForm.name = ''
      // }
    },
    closeRealNameDialog() {
      this.showRealNameDialog = false
      location.href = `/burerSubmitOutcome?order_no=${this.order_no}`
    },
    goRealName() {
      this.showRealNameDialog = false
      this.underage = false
      window.open(this.readnameUrl)
      this.goRealNameTime = 3
      this.readnameUrl = ''
      location.href = `/burerSubmitOutcome?order_no=${this.order_no}`
    },
    realNameCountdown() {
      setTimeout(() => {
        if (!this.showRealNameDialog) {
          return
        }
        if (this.goRealNameTime-- === 1) {
          this.goRealName()
          // document.getElementById("my-dialog-btn").click()
          return
        }
        this.realNameCountdown()
      }, 1000);
    },
    saveInfo() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          let param = JSON.parse(JSON.stringify(this.ruleForm))
          if(param.sign_type == 1){
            // 交易合同
            if(this.partyData.length<=0 || this.signActiveId == ''){
              this.$message({
                message: '请选择签署人',
                center: true,
                offset: 200,
                customClass: 'sell-contract-msg'
              })
              this.btnLoading = false
              return
            }
            param.signatory_id = this.signActiveId
            delete param.name
            delete param.phone
          } else {
            // 包赔

          }
          apiBuyerInformationAdd({
            rd: this.$route.query.rd,
            client: this.userToken ? 'moblie' : 'front',
            ...param,
            order_id: this.order_id,
            admin_id: this.admin_id,
            room_id: this.room_id,
            rd: this.$route.query.rd
          }).then(res =>{
            const readnameUrl = res.data.auth_url
            if(readnameUrl) {
              this.readnameUrl = readnameUrl
              this.showRealNameDialog = true
              // if (!this._isMobile()) {
              //   this.realNameCountdown()
              // }
            } else {
              location.href = `/burerSubmitOutcome?order_no=${this.order_no}`
            }
            setTimeout(() => {
              this.btnLoading = false
            }, 400)
          }).catch(err => {
            this.$message({
              message: err.msg,
              center: true,
              offset: 200,
              customClass: 'sell-contract-msg'
            })
            this.btnLoading = false
          })
        }else{
          scrollIntoView()
          this.$message({
            message: '请正确填写相关信息',
            center: true,
            offset: 200,
            customClass: 'sell-contract-msg'
          })
        }
      })
    },
    _isMobile() {
      return is_mobile;
    },

    provinceChange(e, flag) {
      if (e == '') {
        this.cityList = []
      } else {
        this.cityList = this.ChinaAddressArea.filter(item => item.value == e)[0].children || []
        this.districtList = []
      }
      if (flag) {
        this.cityChange(this.editPartyForm.city, true)
      } else {
        this.editPartyForm.city = ''
        this.editPartyForm.area = ''
      }
    },
    cityChange(e, flag) {
      if (e == '') {
        this.districtList = []
      } else {
        this.districtList = this.cityList.filter(item => item.value == e)[0].children || []
      }
      if (flag) { } else {
        this.editPartyForm.area = ''
      }
    },
  },
};
</script>

<style lang="less">
@import "./styles/contractFeedback.less";
</style>

<style lang="less" scoped>
@import "./styles/contractFormPage.less";

.contract-form-page(72px, buyerInformation, buyerInformation-top, buyerInformation-main, buyerInformation-btn);

.quit-mark {
  position: fixed;
  z-index: 999999;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .quit-box {
    max-width: 359px;
    background: #ffffff;
    border-radius: 4px;
    box-sizing: border-box;
    position: relative;
    img{
      width: 100%;
      height: 100%;
    }
    .el-icon-close{
      position: absolute;
      right: 10px;
      top: 10px;
      font-size: 20px;
      font-weight: bold;
      color: #fff;
    }
    .quit_btn{
      cursor: pointer;
      position: absolute;
      left: calc(50% - 130px);
      bottom: 20px;
      width: 259px;
      height: 25px;
      line-height: 25px;
      text-align: center;
      background: var(--primary, #FF5A1F);
      color: #FFFFFF;
      border: 1px solid var(--primary, #FF5A1F);
      border-radius: 4px;
      font-weight: bold;
      font-family: PingFang SC-Medium, PingFang SC;
      font-size: 12px;
      .el-icon-arrow-right{
        background: #000;
        color: #fff;
        width: 14px;
        height: 14px;
        line-height: 14px;
        border-radius: 50%;
        margin-left: 5px;
        display: inline-block;
        text-align: center;
      }
    }
  }
}
/deep/.el-upload--picture-card{
  width: 100px;
  height: 100px;
  line-height: 100px;
  overflow: hidden;
  border-radius: 4px;
}

.dialog-realname {
  margin-top: 12px;
  color: #999;

  i {
    color: var(--primary, #FF5A1F);
  }
}

.buyerInformation {
  min-height: 100vh;

  &-title {
    margin: 0 0 13px;
    font-size: 24px;
    line-height: 30px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
  }

  .buyerInformation-main {
    .certContractSign-card-body {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      justify-content: center;
      padding: 80px 80px 0;
    }

    .certContractSign-card-body-form {
      width: 100%;
      height: 100%;

      .el-radio {
        margin-right: 80px;
      }

      .prop-fail {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: 68%;
        height: 17px;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #ff7979;

        img {
          width: 13px;
          height: 13px;
        }
      }
    }

    .certContractSign-card-body-form-top {
      &-title {
        display: flex;
        align-items: center;
        padding-bottom: 20px;
        border-bottom: 1px solid var(--border-soft, #E8E4DE);

        &-gameinfo {
          font-size: 18px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: var(--text-main, #111827);
        }

        img {
          width: 12px;
          height: 12px;
          display: inline-block;
          margin: 0 1px 0 8px;
        }
      }

      &-content {
        margin-top: 30px;

        .sign-type {
          display: flex;
          justify-content: space-between;
          width: 751px;

          .sign-type-tip {
            display: flex;
            align-items: center;
            margin: 10px 0 7px;
            padding: 0 23px 0 15px;
            box-sizing: border-box;
            height: 37px;
            background: #FFF6F6;
            border-radius: 4px;
            border: 1px solid #FFDCDC;
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #D06666;

            i {
              font-size: 15px;
              margin-right: 5px;
            }
          }

          .sign-tip {
            cursor: pointer;
            height: 40px;
            line-height: 40px;
            margin-bottom: 22px;
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: var(--primary, #FF5A1F);
          }
        }

        &-from {
          margin-bottom: 90px;
        }
      }
    }

    .certContractSign-card-body-form-bottom {
      .abroad {
        &-select {
          width: 26%;
          margin-right: 15px;
        }

        .el-input {
          width: 57%;
        }
      }

      &-tip {
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
      }

      &-content {
        margin-top: 55px;

        &-realname {
          font-size: 14px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: var(--primary, #FF5A1F);

          .el-input {
            width: 615px !important;
          }
        }

        &-province {
          display: flex;
          justify-content: space-between;
          width: 85% !important;

          .el-select {
            width: 30%;
          }
        }

        &-address {
          margin-top: 15px;
          width: 85%;
        }
      }
    }
  }

  .buyerInformation-btn {
    button.sub {
      margin-left: 0;
    }
  }

  @media screen and (max-width: 900px) {
    .buyerInformation-main {
      .certContractSign-card-body {
        padding: 20px 40px 0;
      }

      .certContractSign-card-body-form {
        .prop-fail {
          width: 100%;
          right: 0;
        }
      }

      .certContractSign-card-body-form-top {
        ::v-deep .el-form-item {
          margin-bottom: 0;
        }

        &-title {
          padding-bottom: 0;
          border-bottom: none;
        }

        &-gameinfo {
          font-size: 16px;
          font-weight: 500;
        }

        &-content {
          margin-top: 20px;

          ::v-deep .el-form-item .el-form-item__label {
            padding: 0;
            margin: 20px 0;
          }

          ::v-deep .el-form-item__label {
            line-height: 0;
          }

          ::v-deep .el-radio__label {
            font-size: 12px;
          }

          .el-radio-group {
            margin-top: 10px;
            display: flex;
            justify-content: space-between;

            .el-radio {
              margin: 10px 0;

              ::v-deep .el-radio__label {
                padding-left: 3px;
              }
            }
          }

          .sign-type {
            width: 100%;
          }
        }
      }

      .certContractSign-card-body-form-bottom {
        ::v-deep .el-radio-group {
          display: flex;
        }

        ::v-deep .el-radio__label {
          font-size: 12px;
          padding-left: 5px;
          margin-right: 38px;
        }

        .el-radio {
          margin-right: 0;
        }

        &-content {
          margin-top: 0;

          &-realname {
            .el-input {
              width: 100% !important;
            }
          }

          &-address {
            width: 100%;
          }

          ::v-deep .el-form-item {
            margin-bottom: 0;
          }

          ::v-deep .el-input__inner {
            width: 100%;
            font-size: 12px;
          }
        }

        ::v-deep .el-form-item__label {
          padding: 0;
          line-height: 0;
          margin: 20px 0;
          color: #666666;
        }
      }
    }

    .bottom-title {
      margin-top: 52px;
    }
  }
}

.certContractSign {
  width: 100vw;
  min-height: 100vh;
  background: linear-gradient(
    to bottom,
    #D8D2CA 0%,
    #D8D2CA 278px,
    #f9fafb 278px,
    #f9fafb 100%
  );

  &-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1160px;
    // height: 199px;
    height: 156px;
    padding: 0 16px 0 24px;
    margin: 0 auto;

    &-text {
      &-title {
        font-size: 24px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        margin: 0 0 8px;
      }

      &-sn {
        font-size: 20px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }
    }

    &-logo {
      img {
        width: 254.28px;
        height: 68.34px;
      }
    }
  }

  &-card {
    width: 1200px;
    // height: 773px;
    // height: 995px;
    background: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    margin: 0 auto;
    overflow: auto;

    &-body {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      // height: 100%;
      padding: 80px 80px 98px;
      &-form {
        width: 100%;
        height: 100%;
        .el-radio {
          margin-right: 80px;
        }
        .prop-fail {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          width: 68%;
          height: 17px;
          font-size: 12px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #ff7979;
          img {
            width: 13px;
            height: 13px;
          }
        }
        &-top {
          &-title {
            display: flex;
            align-items: center;
            padding-bottom: 20px;
            border-bottom: 1px solid #dee3ec;
            &-gameinfo {
              font-size: 18px;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600;
              color: #333333;
            }
            img {
              width: 12px;
              height: 12px;
              display: inline-block;
              margin: 0 1px 0 8px;
            }
            &-search {
              font-size: 12px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #F0EDE8;
              cursor: pointer;
            }
          }
          &-content {
            margin-top: 30px;
            &-uploadimg {
              &-text {
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                margin-bottom: 60px;

              }
              &-img {
                height: 100px;
                display: flex;
                margin-top: 10px;
                &-left {
                  width: 100px;
                  height: 100px;
                }
                &-right {
                  width: 16px;
                  height: 16px;
                  cursor: pointer;
                }
                .upload-box{
                  position: relative;
                  .delete{
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100px;
                    height: 100px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: rgba(0, 0, 0, 0.5);
                    border-radius: 4px;
                    i{
                      color: #ffffff;
                      font-size: 16px;
                    }
                  }
                }
              }
              &-tip {
                width: 9px;
                height: 20px;
                font-size: 16px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #ff0e0e;
                margin-right: 6px;
              }
            }
            .sign-type{
              display: flex;
              justify-content: space-between;
              width: 751px;
              .sign-type-tip{
                display: flex;
                align-items: center;
                margin: 10px 0 7px;
                padding: 0 23px 0 15px;
                box-sizing: border-box;
                height: 37px;
                background: #FFF6F6;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #FFDCDC;
                font-size: 12px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #D06666;
                i{
                  font-size: 15px;
                  margin-right: 5px;
                }
              }
              .sign-tip{
                cursor: pointer;
                height: 40px;
                line-height: 40px;
                margin-bottom: 22px;
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #F0EDE8;
              }
            }
            &-from{
              margin-bottom: 90px;
            }
          }
        }
        &-bottom {
          .abroad {
            &-select {
              width: 26%;
              margin-right: 15px;
            }
            .el-input {
              width: 57%;
            }
          }
          &-tip {
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
          }
          &-content {
            margin-top: 55px;
            &-realname {
              font-size: 14px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #F0EDE8;
              cursor: pointer;
              .el-input {
                width: 615px !important;
              }
            }
            &-province {
              display: flex;
              justify-content: space-between;
              width: 85% !important;
              .el-select {
                width: 30%;
              }
            }
            &-address {
              margin-top: 15px;
              width: 85%;
            }
          }
          &-btn {
            width: 100%;
            margin-top: 80px;
            display: flex;
            justify-content: center;
            button {
              width: 250px;
              border-radius: 4px;
              font-size: 18px;
              font-weight: 500;
              text-align: center;
            }
            &-reset {
              margin-right: 30px;
              border: 1.5px solid var(--bg-dark, #1A1D24);
              background-color: transparent;
              color: var(--text-main, #1A1D24);
            }
            &-sub {
              border: 1px solid var(--primary, #FF5A1F);
              background-color: var(--primary, #FF5A1F);
              color: #FFFFFF;
              &:hover {
                background-color: var(--primary-hover, #E84A12);
                border-color: var(--primary-hover, #E84A12);
              }
            }
          }
          &-img {
            width: 400px;
            height: 33px;
            background: #f0f4ff;
            border-radius: 4px 4px 4px 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 57px;
            img {
              width: 22.94px;
              height: 13px;
              margin-right: 6px;
            }
            span {
              font-size: 14px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #5A5F6B;
            }
          }
        }
      }

      &-img {
        img {
          width: 211px;
          height: 249px;
        }
      }

      &-content {
        margin: 42px 0 68px;

        div {
          text-align: center;
        }

        div:first-of-type {
          font-size: 20px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #F0EDE8;
          margin: 0 0 4px;
        }

        div:last-of-type {
          font-size: 16px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #666666;
        }
      }

      &-btn {
        width: 150px;
        height: 40px;
        line-height: 40px;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        border: 1px solid #F7F5F2;
        text-align: center;
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #F7F5F2;
        cursor: pointer;
      }
    }
  }

  @media screen and (max-width: 1300px) {
    &-head {
      justify-content: center;
      width: 100%;
      height: 174px;
      padding: 0;

      &-logo {
        display: none;
      }
    }

    &-card {
      width: calc(100% - 22px * 2);
      margin: 0 24px 40px;
      // height: 625px;

      &-body {
        height: 100%;

        &-content {
          margin: 19px 0 60px;
          div:first-of-type {
            margin: 0 0 8px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 900px) {
    background: none;
    &-head {
      background-image: url("~@/assets/image/Contract/sell-img.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 100% 90%;
      align-items: flex-start;
      &-text {
        margin-top: 13px;
        &-title {
          margin: 0 0 8px;
        }
        &-sn {
          font-size: 14px;
        }
      }
    }
    &-card {
      margin-top: -87px;
      overflow-x: hidden;
      .realInfo {
        position: relative;
        .real {
          position: absolute;
          top: -40px;
          right: 0;
        }
      }
      &-body {
        padding: 20px 40px 0;
        &-form {
          .prop-fail {
            width: 100%;
            right: 0;
          }
          &-top {
            ::v-deep .el-form-item {
              margin-bottom: 0;
            }
            &-title {
              padding-bottom: 0;
              border-bottom: none;
            }
            &-gameinfo {
              font-size: 16px;
              font-weight: 500;
            }
            &-content {
              ::v-deep .el-form-item .el-form-item__label {
                padding: 0;
                margin: 20px 0;
              }
              ::v-deep .el-form-item__label {
                line-height: 0;
              }
              ::v-deep .el-radio__label {
                font-size: 12px;
              }
              margin-top: 20px;
              .el-radio-group {
                margin-top: 10px;
                display: flex;
                justify-content: space-between;
                .el-radio {
                  margin-right: 0;
                  margin: 10px 0;
                  ::v-deep .el-radio__label {
                    padding-left: 3px;
                  }
                  .el-radio:nth-child(2) {
                    margin: 0 49px;
                  }
                }
              }
              &-uploadimg {
                margin-left: 0;
                &-text {
                  font-size: 12px;
                }
              }
            }
          }
          .province {
            justify-content: space-around;
            width: 100% !important;
          }

          &-bottom {
            ::v-deep .el-radio-group {
              display: flex;
            }
            ::v-deep .el-radio__label {
              font-size: 12px;
              padding-left: 5px;
              margin-right: 38px;
            }
            .el-radio {
              margin-right: 0;
            }
            &-content {
              margin-top: 30px;
              &-realname {
                .el-input {
                  width: 100% !important;
                }
              }
              .realInfo {
                .real {
                  font-size: 12px;
                }
              }
              &-address {
                width: 100%;
              }
              margin-top: 0;
              ::v-deep .el-form-item {
                margin-bottom: 0;
              }
              ::b-deep .el-form-item__label:nth-child(1) {
                font-size: 14px;
              }
              ::v-deep .el-input__inner {
                width: 100%;
                font-size: 12px;
              }
            }
            &-btn {
              margin-top: 40px;
              button {
                width: 150px;
                height: 40px;
                font-size: 16px;
                padding: 0;
                line-height: 0;
              }
              &-reset {
                margin-right: 20px;
              }
            }
            &-img {
              width: 375px;
              height: 33px;
              background: #f0f4ff;
              margin-top: 13px;
              img {
                width: 20px;
                height: 11.76px;
                margin-right: 6px;
              }
              span {
                font-size: 12px;
              }
            }
            ::v-deep .el-form-item__label {
              padding: 0;
              line-height: 0;
              margin: 20px 0;
              color: #666666;
            }
            .abroad {
              &-select {
                width: 35%;
                margin-right: 4px;
              }
              .el-input {
                width: 62%;
              }
            }
          }
        }
        &-img {
          img {
            width: 145px;
            height: 171.11px;
          }
        }
      }
    }
    .select /deep/ .el-input__inner {
      width: 100%;
    }
    .bottom-title {
      margin-top: 52px;
    }
  }
}
</style>
